<app-sidebar></app-sidebar>

<div class="layout-sidebar-push layout-body">
    <div class="tabs-container">
        <h2 class="head-main">{{ 'offers.list.heading' | translate }}</h2>
    </div>

    <div class="filter-tabs">
        <a class="filter-tab" [class.active]="tab === 'ACTIVE'" (click)="onChangeTab('ACTIVE')">
            {{ 'offers.list.tab.active' | translate }}
            <div class="filter-tab-values">
                <div class="value">{{ totals.active | localizedNumber }}</div>
            </div>
        </a>

        <a class="filter-tab" [class.active]="tab === 'PENDING'" (click)="onChangeTab('PENDING')">
            {{ 'offers.list.tab.pending' | translate }}
            <div class="filter-tab-values">
                <div class="value">{{ totals.pending | localizedNumber }}</div>
            </div>
        </a>

        <a class="filter-tab" [class.active]="tab === 'ENDED'" (click)="onChangeTab('ENDED')">
            {{ 'offers.list.tab.ended' | translate }}
            <div class="filter-tab-values">
                <div class="value">{{ totals.ended | localizedNumber }}</div>
            </div>
        </a>

        <a class="filter-tab" [class.active]="tab === 'ALL'" (click)="onChangeTab('ALL')">
            {{ 'offers.list.tab.all' | translate }}
            <div class="filter-tab-values">
                <div class="value">{{ totals.all | localizedNumber }}</div>
            </div>
        </a>
    </div>

    <app-loading *ngIf="loading"></app-loading>

    <app-offer-table
        *ngIf="!loading"
        (pageChange)="onPageChange($event)"
        (filtersChange)="onFiltersChange($event)"
        (orderingChange)="onOrderingChange($event)"
        [ordering]="ordering"
        [filters]="filters"
        [page]="page"
        [perPage]="perPage"
        [total]="total"
        [offers]="offers">
    </app-offer-table>
</div>
